import { VehicleAxlesList } from '@src/axles/domain/VehicleAxlesList';
import { AxleClient } from '@src/axles/service/AxleClient';
import { useQuery } from '@tanstack/react-query';

export const useAxleList = (clientId: string) => {
  const {
    data: axles = new VehicleAxlesList({
      trailersAxles: [],
      tractorsAxles: [],
    }),
    isLoading,
  } = useQuery<VehicleAxlesList>({
    queryKey: ['axles.list', clientId],
    queryFn: () => AxleClient.list(clientId),
  });

  return {
    axles,
    isLoading,
  };
};
